module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localModel),
      expression: "localModel"
    }],
    attrs: {
      "id": _vm.id,
      "type": "radio",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm._q(_vm.localModel, _vm.value)
    },
    on: {
      "change": function (e) { return _vm.$emit('updateValue', e.target.value); },
      "__c": function($event) {
        _vm.localModel = _vm.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca67e60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/RadioInput.vue
// module id = 3132
// module chunks = 0